module.exports = __webpack_public_path__ + "static/media/pentester.db5093f5.jpg";